import React, { FC } from 'react'
import {
  FormControlLabel,
  FormControlLabelProps as FormControlLabelPropsInterface,
  Switch as MuiSwitch,
  SwitchProps as MuiSwitchProps,
} from '@mui/material'

export interface SwitchProps {
  label: string;
  name: string;
  required?: boolean;
  disabled?: boolean;
  SwitchProps?: Omit<MuiSwitchProps, 'name' | 'required' | 'disabled'>;
  FormControlLabelProps?: Omit<
    FormControlLabelPropsInterface,
    'name' | 'checked' | 'value' | 'disabled' | 'control' | 'label'
  >;
}

export const Switch: FC<SwitchProps> = ({
  label,
  name,
  required = false,
  disabled = false,
  SwitchProps,
  FormControlLabelProps,
}) => {
  return (
    <FormControlLabel
      {...FormControlLabelProps}
      disabled={disabled}
      checked={SwitchProps?.checked || false}
      value={SwitchProps?.value || ''}
      name={name}
      label={label}
      control={
        <MuiSwitch
          {...SwitchProps}
          name={name}
          required={required}
          disabled={disabled}
        />
      }
    />
  )
}
